import meta from './meta';
import ModelContainer from '../components/model-container.js';

export default function (url, options) {
    const token = meta.value("_csrf");

    options = options || {};
    options.headers = options.headers || new Headers();
    if(!(options.headers instanceof Headers)) {
        options.headers = new Headers(options.headers);
    }
    if(token) {
        options.headers.append('X-CSRF-Token', token);
    }
    //pageViewId is only meant for tracking purposes
    if(ModelContainer.get("pageViewId")) {
        options.headers.append('pageViewId', ModelContainer.get("pageViewId"))
    };
    options.credentials = options.credentials || 'same-origin'; // Must be set in Edge for CSRF to work
    window.ajaxRequestsPending++;   //counter for Selenium
    return fetch(url, options).then((response) => {
        window.ajaxRequestsPending--;
        return response;
    });
}
